
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mvpd",
      function () {
        return require("private-next-pages/mvpd/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mvpd"])
      });
    }
  